module.exports = __webpack_public_path__ + "img/cars.6954b85f.svg";